import { render, staticRenderFns } from "./FilesRequestTable.vue?vue&type=template&id=882c7058&scoped=true"
import script from "./FilesRequestTable.vue?vue&type=script&lang=js"
export * from "./FilesRequestTable.vue?vue&type=script&lang=js"
import style0 from "./FilesRequestTable.vue?vue&type=style&index=0&id=882c7058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882c7058",
  null
  
)

export default component.exports